module.exports = __webpack_public_path__ + "static/media/setup.e68e907e.svg";